module.exports = __webpack_public_path__ + "static/media/information.f526e389.svg";